export default () => {
  localStorage.removeItem("SSO");
  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.clear();
};
